import Component from '../abstracts/Component';
import TrackingComponent from './TrackingComponent';

export default class NotifyMeComponent extends Component {

  constructor(compEl) {
    super(compEl);
    this.TrackingComponent = new TrackingComponent();
    this.notifyText = this.$component.querySelector(this.SELECTORS.notifyText);
    this.notifyForm = this.$component.querySelector(this.SELECTORS.notifyForm);
    this.notifyFormBtn = this.$component.querySelector(this.SELECTORS.notifyFormBtn);
    this.notifyConfirm = this.$component.querySelector(this.SELECTORS.notifyConfirm);
    this.notifyFormInput = this.$component.querySelector(this.SELECTORS.notifyFormInput);
    this.notifyFormInputElement = this.$component.querySelector(this.SELECTORS.notifyFormInputElement);
    this.notifyEmailError = this.$component.querySelector(this.SELECTORS.notifyEmailError);
    this.notifySizeError = this.$component.querySelector(this.SELECTORS.notifySizeError);
    this.notifyGenericError = this.$component.querySelector(this.SELECTORS.notifyGenericError);
    this.productCodeInput = this.$component.querySelector(this.SELECTORS.productCodeInput);
    this.notifyCheck = this.$component.querySelector(this.SELECTORS.notifyCheck);
    this.buttonMsg = this.$component.querySelector(this.SELECTORS.buttonMsg);
    this.buttonEmailIcon = this.$component.querySelector(this.SELECTORS.buttonEmailIcon);
    this.isFloatingBar = this.$component.dataset.floatingBar === 'true';
    this.productCode = this.$component.dataset.productCode;
    this.selectSizeLayerCloseBtn = this.$component.querySelector(this.SELECTORS.selectSizeLayerCloseBtn);
  }

  get COMPONENTNAME() {
    return 'NotifyMeComponent';
  }

  get SELECTORS() {
    return {
      notifyText: '[data-form-text]',
      notifyForm: '[data-js-form]',
      notifyFormInput: '[data-mail-box]',
      notifyFormInputElement: '[data-mail-box-input]',
      notifyFormBtn: '[data-notify-me-btn]',
      notifyConfirm: '[data-form-thanks]',
      notifyEmailError: '#emailError',
      notifySizeError: '#sizeError',
      notifyGenericError: '#genericError',
      productCodeInput: '#productCode',
      notifyCheck: '[data-notify-check]',
      buttonMsg: '.custom-button__message',
      buttonEmailIcon: '.icon-mail',
      selectSizeLayerCloseBtn: '[data-sizes-layer-close]',
    };
  }

  get CLASSES() {
    return {
      hidden: '--hidden',
      loading: '--loading',
      error: 'error'
    }
  }

  bindEvents() {
    //handle show form
    this.$on(this.$customEvents.PRODUCT_EVENTS.notifyme, ({event, payload}) => {

      if (payload.productCode && payload.productCode === this.productCode) {
        this.showNotifyMe();
      }
    });
    //handle close form
    this.$on(this.$customEvents.PRODUCT_EVENTS.notifymeclose, ({event, payload}) => {
      if (payload.productCode && payload.productCode === this.productCode) {
        //hide and reset form, disable button
        this.closeNotification();
      }
    });
    if (this.selectSizeLayerCloseBtn) {
      this.selectSizeLayerCloseBtn.addEventListener('click', () => {
        this.closeNotification();
      });
    }

    //handle size selection, change input value
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged, ({event, payload}) => {
      if (payload.baseProductCode === this.$component.dataset.productCode) {
        this.productCodeInput.value = payload.productCode;
      }
    });
  }

  // submit form
  bindSubmit() {
    this.notifyForm.addEventListener("submit", event => {
      event.preventDefault();
      event.stopPropagation();
      this.notifyFormInputElement.classList.remove(this.CLASSES.error);
      this.notifyEmailError.classList.add(this.CLASSES.hidden);
      this.notifySizeError.classList.add(this.CLASSES.hidden);
      this.notifyGenericError.classList.add(this.CLASSES.hidden);

      const url = this.notifyForm.action;
      const data = new FormData(this.notifyForm);
      this.notifyFormBtn.classList.add(this.CLASSES.loading);
      this.buttonEmailIcon?.classList.add(this.CLASSES.hidden);
      this.notifyFormBtn.disabled = true;
      const isUniqueSize = this.notifyForm.dataset.uniquesize === 'true';
      const isAvailable = this.notifyForm.dataset.available === 'true';
      const isCompleteLook = this.notifyForm.dataset.completeLook === 'true';

      fetch(url, {
        method: 'POST',
        body: data
      })
        .then(async response => {
          if (response.ok) {
            return response.text().then(text => {

              //show success message
              this.notifyConfirm.classList.remove(this.CLASSES.hidden);
              //hide input box
              this.notifyText.classList.add(this.CLASSES.hidden);

              this.notifyFormBtn.classList.remove(this.CLASSES.loading);
              this.buttonEmailIcon?.classList.remove(this.CLASSES.hidden);

              //change button content
              this.buttonMsg.classList.add(this.CLASSES.hidden);
              this.notifyCheck.classList.remove(this.CLASSES.hidden);
              this.buttonEmailIcon?.classList.add(this.CLASSES.hidden);
              setTimeout(() => {
                this.$emit(this.$customEvents.PRODUCT_EVENTS.notifymesuccess, {productCode: this.productCode, completeLook: isCompleteLook});

                if (!isCompleteLook) this.closeNotification();
                else {
                  this.$emit(this.$customEvents.PRODUCT_EVENTS.notifymereset);
                  if (!isAvailable) {
                    this.showNotifyMe();
                    // reset size selected
                    this.notifyFormInputElement.querySelector('input').value = '';
                    if (!isUniqueSize) this.productCodeInput.value = '';
                  }
                }

                this.$emit(this.$customEvents.NOTIFY_ME_STATE.sent);
              }, 3000);

              const productCode = data.get("productCode");
              if (productCode) {
                this.TrackingComponent.actions.notifyMe(productCode);
              }
            });
          } else {
            this.notifyFormBtn.disabled = false;
            if (!data.get("email") || data.get("email") === "") {
              // show error email empty
              this.notifyFormInputElement.classList.add(this.CLASSES.error);
              this.notifyEmailError.classList.remove(this.CLASSES.hidden);
            } else if ((!data.get("productCode") || data.get("productCode") === "") && !isUniqueSize) {
              //show error size not selected
              if (isCompleteLook) {
                this.notifyFormInputElement.classList.add(this.CLASSES.error);
                this.notifySizeError.classList.remove(this.CLASSES.hidden);
              } else {
                this.$emit(this.$customEvents.PRODUCT_EVENTS.sizerequired, this.notifyFormBtn);
              }
            } else {
              // show message received by service
              const message = await response.text();
              this.notifyGenericError.innerHTML = message || "";
              this.notifyFormInputElement.classList.add(this.CLASSES.error);
              this.notifyGenericError.classList.remove(this.CLASSES.hidden);
            }
            this.notifyFormBtn.classList.remove(this.CLASSES.loading);
            this.buttonEmailIcon?.classList.remove(this.CLASSES.hidden);
          }
        })
        .catch(async (error) => {
          // possibly useless catch
          this.notifyFormBtn.disabled = false;
          if (!data.get("email") || data.get("email") === "") {
            // show error email empty
            this.notifyFormInputElement.classList.add(this.CLASSES.error);
            this.notifyEmailError.classList.remove(this.CLASSES.hidden);
          } else if ((!data.get("productCode") || data.get("productCode") === "") && !isUniqueSize) {
            //show error size not selected
            this.$emit(this.$customEvents.PRODUCT_EVENTS.sizerequired, this.notifyFormBtn);
          } else {
            // show message received by service
            const message = await response.text();
            this.notifyGenericError.innerHTML = message || "";
            this.notifyFormInputElement.classList.add(this.CLASSES.error);
            this.notifyGenericError.classList.remove(this.CLASSES.hidden);
          }
          this.notifyFormBtn.classList.remove(this.CLASSES.loading);
          this.buttonEmailIcon?.classList.remove(this.CLASSES.hidden);
        });
    });
  }

  closeNotification() {
    this.$component.classList.add(this.CLASSES.hidden);
    this.notifyFormInput.classList.remove(this.CLASSES.hidden);
    this.notifyFormBtn.disabled = true;
    this.notifyFormInputElement.classList.remove(this.CLASSES.error);
    this.notifyEmailError.classList.add(this.CLASSES.hidden);
    this.notifySizeError.classList.add(this.CLASSES.hidden);
    this.notifyConfirm.classList.add(this.CLASSES.hidden);
    this.notifyForm.reset();
  }

  showNotifyMe() {
    //open form and enable button
    this.$component.classList.remove(this.CLASSES.hidden);
    this.notifyText.classList.remove(this.CLASSES.hidden);
    this.notifyFormInputElement.classList.remove(this.CLASSES.error);
    this.notifyEmailError.classList.add(this.CLASSES.hidden);
    this.notifySizeError.classList.add(this.CLASSES.hidden);
    this.notifyConfirm.classList.add(this.CLASSES.hidden);
    this.notifyFormInput.classList.remove(this.CLASSES.hidden);

    //change button content
    this.buttonMsg.classList.remove(this.CLASSES.hidden);
    this.notifyCheck.classList.add(this.CLASSES.hidden);
    this.buttonEmailIcon?.classList.remove(this.CLASSES.hidden);

    //enable button
    this.notifyFormBtn.disabled = false;
  }

  render() {
    this.log("Rendering...");
    this.bindEvents();
    this.bindSubmit();
  }
}
